import { ReactElement } from "react";
import { useDispatch } from "react-redux";

import { searchActions } from "store/search/searchSlice";

export default function QuickSearchButton({
  children,
  className,
}: {
  className?: string;
  children: ReactElement;
}): JSX.Element {
  const dispatch = useDispatch();

  const toggleQuickSearch = () => {
    dispatch(searchActions.toggleSearchVisible());
  };

  return (
    <button
      type="button"
      className={className}
      onClick={() => toggleQuickSearch()}
    >
      {children}
    </button>
  );
}
